import {
  buildQueryParams,
  haveFilterQuery,
  paginator,
  haveSort,
} from '../common/auxFun'

const BASE_PATH = '/v1/accountingEntry'

const endpointsAccountingEntry = {
  // TODO: limit, skip NO SE ACEPTAN???
  ACCOUNTING_ENTRY: (companyCode, filter, sort, limit, skip) =>
    `${BASE_PATH}/accountingEntry${buildQueryParams({ filter, sort, customParams: [{ id: 'companyCode', value: companyCode }] })}`,
  ACCOUNTING_ENTRY_LAST: (companyCode, year, month, filter, sort) =>
    `${BASE_PATH}/accountingEntry/last${buildQueryParams({
      filter,
      sort,
      customParams: [
        { id: 'companyCode', value: companyCode },
        { id: 'year', value: year },
        { id: 'month', value: month },
      ],
    })}`,
  COMPANIES: (filter, sort, limit, skip) =>
    `${BASE_PATH}/companies${buildQueryParams({ filter, limit, skip, sort })}`,
  GENERATE: `${BASE_PATH}/accountingEntry`,
  SEND: (id) => `${BASE_PATH}/accountingEntry/${id}/send`,
  DOWNLOAD: (id) => `${BASE_PATH}/accountingEntry/${id}/download`,

  ACCOUNTS: {
    LOAD: (companyCode, filter, sort, limit, skip) =>
      `${BASE_PATH}/accounts${buildQueryParams({ filter, limit, skip, sort, customParams: [{ id: 'companyCode', value: companyCode }] })}`,
  },

  AGREEMENTS: {
    LOAD: (companyCode, filter, sort, limit, skip) =>
      `${BASE_PATH}/agreements${buildQueryParams({ filter, sort, customParams: [{ id: 'companyCode', value: companyCode }] })}`,
  },

  ANALITICS: {
    LOAD: (id, filter, sort, limit, skip) => `${BASE_PATH}/analitics/${id}`,
    ACCOUNTING_ENTRY_LOAD: (id, filter, sort, limit, skip) =>
      `${BASE_PATH}/analitics/accountingEntry/${id}`,
  },

  CONCEPTS: {
    LOAD: (companyCode, agreementCode, filter, sort, limit, skip) =>
      `${BASE_PATH}/concepts${buildQueryParams({
        filter,
        sort,
        limit,
        skip,
        customParams: [
          { id: 'companyCode', value: companyCode },
          { id: 'agreementCode', value: agreementCode },
        ],
      })}`,
  },

  PROJECTS: {
    LOAD: (companyCode, filter, sort, limit, skip) =>
      `${BASE_PATH}/projects${buildQueryParams({ filter, sort, limit, skip, customParams: [{ id: 'companyCode', value: companyCode }] })}`,
  },

  TEMPLATES: {
    LOAD: (companyCode, filter, sort, limit, skip) =>
      `${BASE_PATH}/templates${buildQueryParams({ filter, sort, limit, skip, customParams: [{ id: 'companyCode', value: companyCode }] })}`,
    ADD_TEMPLATE: `${BASE_PATH}/templates`,
    UPDATE_TEMPLATE: (id) => `${BASE_PATH}/templates/${id}`,
    DELETE_TEMPLATE: (id) => `${BASE_PATH}/templates/${id}`,
  },

  WORKERS: {
    LOAD: (companyCode, year, month, filter, sort, limit, skip) =>
      `${BASE_PATH}/workers${buildQueryParams({
        filter,
        limit,
        skip,
        sort,
        customParams: [
          { id: 'companyCode', value: companyCode },
          { id: 'year', value: year },
          { id: 'month', value: month },
        ],
      })}`,
    LOAD_WITHOUT_PROJECT: (
      companyCode,
      year,
      month,
      filter,
      sort,
      limit,
      skip,
    ) =>
      `${BASE_PATH}/workers/withoutProject${buildQueryParams({
        filter,
        limit,
        skip,
        sort,
        customParams: [
          { id: 'companyCode', value: companyCode },
          { id: 'year', value: year },
          { id: 'month', value: month },
        ],
      })}`,
    SET_PROJECTS: `${BASE_PATH}/workers`,
    REMOVE: (id) => `${BASE_PATH}/workers/${id}`,
  },
}

export default endpointsAccountingEntry
